import { render, staticRenderFns } from "./SecretStorageSyncOptionsForm.vue?vue&type=template&id=ba453184"
import script from "./SecretStorageSyncOptionsForm.vue?vue&type=script&lang=js"
export * from "./SecretStorageSyncOptionsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports